<particle-smart-dropdown [queryKey]="queryKey"
                         [placeholder]="'Select an Entity'"
                         [displayProperty]="displayProperty"
                         [arguments]="arguments"
                         [dynamicFormControl]="dynamicFormControl"
                         [multiselect]="false"
                         (valueChanged)="onSelectionChange($event)"
                         [disabled]="false"
>
</particle-smart-dropdown>
